import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'

import api from '../../services/api'
import { createPerfLogger } from '../../utils/perfLogger'

const useTickets = ({ searchParam, tags, users, pageNumber, status, date, updatedAt, showAll, queueIds, whatsappIds, withUnreadMessages, ticketScope, awaitingResponse, sortOrder }) => {
  const [loading, setLoading] = useState(true)
  const [hasMore, setHasMore] = useState(false)
  const [tickets, setTickets] = useState([])
  const [count, setCount] = useState(0)

  useEffect(() => {
    let active = true
    setLoading(true)
    const perf = createPerfLogger('useTickets.fetch', {
      status,
      pageNumber,
      ticketScope,
      awaitingResponse,
      sortOrder,
    })

    const fetchTickets = async () => {
      try {
        const { data } = await api.get('/tickets', {
          params: {
            searchParam,
            pageNumber,
            tags,
            users,
            status,
            date,
            updatedAt,
            showAll,
            queueIds,
            whatsappIds,
            withUnreadMessages,
            ticketScope,
            awaitingResponse,
            sortOrder,
          },
        })
        if (!active) return

        const fetchedTickets = Array.isArray(data.tickets) ? data.tickets : []
        perf.mark('response-received', { count: data.count || 0, returnedTickets: fetchedTickets.length })
        setTickets(fetchedTickets)
        setHasMore(Boolean(data.hasMore))
        setCount(data.count || 0)
        setLoading(false)
        perf.finish({ hasMore: data.hasMore })
      } catch (err) {
        if (!active) return

        setLoading(false)
        toastError(err)
      }
    }

    const shouldDebounce = Boolean(searchParam)
    const timeoutId = shouldDebounce ? setTimeout(fetchTickets, 250) : null

    if (!shouldDebounce) {
      fetchTickets()
    }

    return () => {
      active = false
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [searchParam, tags, users, pageNumber, status, date, updatedAt, showAll, queueIds, whatsappIds, withUnreadMessages, ticketScope, awaitingResponse, sortOrder])

  return { tickets, loading, hasMore, count }
}

export default useTickets
